module.exports = __webpack_public_path__ + "static/media/dc8955fddbdb6ac8c47b2351ff031942.e31bfc98.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/posters/dc8955fddbdb6ac8c47b2351ff031942.jpg
// module id = 271
// module chunks = 0